import RecoverAccountPage from './RecoverAccountPage';

export default RecoverAccountPage;


// WEBPACK FOOTER //
// ./src/components/pages/RecoverAccountPage/index.js